import { render, staticRenderFns } from "./calendardetail.vue?vue&type=template&id=1ae4ffae&scoped=true&"
import script from "./calendardetail.vue?vue&type=script&lang=js&"
export * from "./calendardetail.vue?vue&type=script&lang=js&"
import style0 from "./calendardetail.vue?vue&type=style&index=0&id=1ae4ffae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae4ffae",
  null
  
)

export default component.exports